/**
 * @class Toggle
 */
class Toggle {
    constructor(toggleContainer, options) {
        this.toggleContainer = toggleContainer;
        this.$toggleTrigger = $(options.trigger, this.toggleContainer);
        this.$toggleContent = $(options.content, this.toggleContainer);
        this.options = options;

        this.registerEvents();
    }

    registerEvents() {
        this.$toggleTrigger.on('click', this.onTriggerClick.bind(this));
    }

    onTriggerClick() {
        this.$toggleContent.slideToggle();
    }
}

(function($) {
    "use strict";

    /* jquery plugin */
    $.fn.customToggle = function(options) {
        return this.each(function() {
            new Toggle(this, options);
        });
    };
})(jQuery);

export default Toggle;